import { Post, Put } from "#src/HttpClient.ts";
import { type Pinia } from "pinia";

const controller = "/strife/v1/quotes";

export async function fetchQuotes(
  pinia: Pinia,
  args: { pdf: boolean; body: any } = { pdf: false, body: {} }
) {
  let url = controller;
  if (args.pdf) url += ".pdf";

  try {
    const res = await Post(pinia, {
      url,
      includeEappData: true,
      body: args.body,
    });
    return res;
  } catch (e: any) {
    // is axios error. uncertain about type
    throw e?.response?.data?.details || e;
  }
}

export async function setActiveQuote(
  pinia: Pinia,
  quoteId: string | number,
  insured_id: number
) {
  const { data } = await Put(pinia, {
    url: `${controller}/${quoteId}`,
    includeEappData: true,
    body: { insured_id },
  });
  return data.id;
}
